class productHelper{
	constructor() {
		this.bindProductGallery();
	}
	bindProductGallery() {
		document.addEventListener('DOMContentLoaded', () => {
            Array.from(document.querySelectorAll('[data-product-gallery]')).forEach((el) => {
				let productImages = el.querySelectorAll('.product-images .product-image');
				//let currentImageTag = el.querySelector('.current-image img');
				let galleryItems = el.querySelectorAll('.image-gallery .gallery-item');
				galleryItems.forEach((item) => {
					item.addEventListener('click', function(event) {
						event.preventDefault();

						let newImageIndex = item.dataset.index;
						productImages.forEach((item) => {
							item.classList.remove('active');
						});
						productImages[newImageIndex].classList.add('active');

						galleryItems.forEach((item) => {
							item.classList.remove('active');
						});
						item.classList.add('active');
					});
				});
			});
		});
	}
}
window.app.add('product', new productHelper());